import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';

import { InspectionFolder } from '../../shared/models/index';

@Component({
    selector: 'inspectionFolder-edit',
    templateUrl: './edit.component.html',
    standalone: false
})
export class InspectionFolderEditComponent implements OnInit {
  @Input() public inspectionFolder: InspectionFolder;
  @Input() public processing;
  @Output() public toggleSaveInspectionFolder: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();

  editForm: UntypedFormGroup;
  constructor() {}

  ngOnInit(): void {
    this.initForm();
  }

  public updateInspectionFolder(model: any) {
    this.inspectionFolder.name = model.name;
    this.inspectionFolder.description = model.description;
    this.toggleSaveInspectionFolder.emit(this.inspectionFolder);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.inspectionFolder.name, Validators.required),
      description: new UntypedFormControl(this.inspectionFolder != null ? this.inspectionFolder.description : '')
    });
  }
}
